import { z } from "zod";

export const finalDestinationIdSchema = z.string().uuid("ID de destino final inválido");

export const createFinalDestinationSchema = z.object({
  name:      z.string().min(1, "El nombre es requerido").max(200),
  code:      z.string().min(1, "El código es requerido").max(10).toUpperCase(),
  isActive:  z.boolean().optional(),
  sortOrder: z.number().int().min(0).optional(),
});

export const updateFinalDestinationSchema = createFinalDestinationSchema.partial();

export const finalDestinationQuerySchema = z.object({
  deleted: z.enum(["true", "false"]).optional(),
});

export type FinalDestinationId           = z.infer<typeof finalDestinationIdSchema>;
export type CreateFinalDestinationInput  = z.infer<typeof createFinalDestinationSchema>;
export type UpdateFinalDestinationInput  = z.infer<typeof updateFinalDestinationSchema>;
export type FinalDestinationQuery        = z.infer<typeof finalDestinationQuerySchema>;
